import { useState, useEffect } from "react"
import { getStyle, space6 } from "../dist/helpers"
import { MediaCarousel } from "./MediaCarousel"
import blue from "../images/arduinoProject1/blue.jpeg"
import green from "../images/arduinoProject1/green.jpeg"
import red from "../images/arduinoProject1/red.jpeg"
import zoom from "../images/arduinoProject1/zoom.jpeg"
import mb1 from "../images/car1.png"
import mb2 from "../images/car2.png"
import ibinstall from "../images/iBookInstall.MOV"
// blog 4
import amora from "../images/blog4/Amora.png"
import errMov from "../images/blog4/Error.MOV"
import gorg from "../images/blog4/Gorg.jpeg"
import ib9 from "../images/blog4/iB9.jpeg"
import iBBoot from "../images/blog4/iBBoot.jpeg"
import ibinstall2 from "../images/blog4/iBinstall.jpeg"
import iMac from "../images/blog4/iMac.jpeg"
import iMac2 from "../images/blog4/iMac2.jpeg"
import iMac3 from "../images/blog4/Imac3.jpeg"
import iMacTower from "../images/blog4/iMacTower.jpeg"
import MacProDoor from "../images/blog4/MacProDoor.jpeg"
import MacProMax from "../images/blog4/MacProMax.jpeg"
import MacPro from "../images/blog4/MacPro.jpeg"
import MacProMotherboard from "../images/blog4/MacProMotherboard.jpeg"
import mouse from "../images/blog4/mouse.jpeg"
import Somatic from "../images/blog4/Somatic.jpg"
// blog 5
import b5_1 from "../images/Blog5/IMG_4952.jpeg"
import b5_2 from "../images/Blog5/IMG_4978.jpeg"
import b5_3 from "../images/Blog5/IMG_4982.jpeg"
import b5_4 from "../images/Blog5/IMG_5005.jpeg"
import b5_5 from "../images/Blog5/IMG_5115.jpeg"
import b5_6 from "../images/Blog5/IMG_5116.jpeg"
import b5_7 from "../images/Blog5/IMG_5121.jpeg"
import b5_8 from "../images/Blog5/IMG_5145.jpeg"
import b5_9 from "../images/Blog5/IMG_5146.jpeg"
import b5_10 from "../images/Blog5/IMG_5149.jpeg"
import b5_11 from "../images/Blog5/IMG_5151.jpeg"
import b5_12 from "../images/Blog5/IMG_5154.jpeg"
import b5_13 from "../images/Blog5/IMG_5158.jpeg"
import b5_14 from "../images/Blog5/IMG_5160.jpeg"
import b5_15 from "../images/Blog5/IMG_5163.jpeg"
import b5_16 from "../images/Blog5/IMG_5164.jpeg"
import b5_17 from "../images/Blog5/IMG_5200.jpeg"
import b5_18 from "../images/Blog5/IMG_5204.jpeg"
import b5_19 from "../images/Blog5/IMG_5221.jpeg"
import b5_20 from "../images/Blog5/IMG_5235.jpeg"
import b5_21 from "../images/Blog5/IMG_5241.jpeg"
import b5_22 from "../images/Blog5/IMG_5242.jpeg"
import b5_23 from "../images/Blog5/IMG_5248.jpeg"
import b5_24 from "../images/Blog5/IMG_5259.jpeg"
import b5_25 from "../images/Blog5/IMG_5264.jpeg"


const items = [
  {
    index: 0,
    head: "First entry: Learning how to acquire a captive audience",
    body: "There are many things in this world fighting for our attention. " +
      "Especially crap ideas like NFTs and altcoins. " +
      "While I am not usually entertained by things like that, I do however, like to watch content on crypto scams :)",
    variation: "outlined",
    date: "2022"
  },
  {
    index: 1,
    head: "Second entry: Learning how to program microcontrollers and embedded devices",
    body: "RaspberryPi and ArduinoUno are some of the most popular devices you can get out there on the market today. " +
      "Which is why I fully believe these will be among my next impulse buys of 2022. What will you " +
      "create with them you might ask. Not exactly sure. But to be fair, when I created this website, " +
      "I also did not yet know its purpose. Sometimes it's better to just let things come to you. ",
    variation: "elevated",
    date: "2022"
  },
  {
    index: 2,
    head: "Third entry: First stab at Arduino, buttons, breadboards, and LEDs",
    body: "Here is my first step on the journey to creating a desktop stock ticker + graph and other related side projects like a crystal ps4 controller led conversion kit. In order to be able to tackle projects that large I figured it’d be best to start learning the fundamentals. So that’s basically what this is, just a demonstration of proficiency in wiring basics, using a breadboard, gaining back my soldering skills, and remembering how to write code for the Arduino. One thing I really like about this project is that there are many pieces that must work in order for something so seemingly simple to be pulled off.",
    body2: "All this device really does is allow for a person to press a button and have that randomly cycle the colors of the LEDs. But behind the scenes there was a lot that went into making that happen. One fun issue I ran into while making this invention was that when I purchased the LEDs, they were not soldered to breadboard legs or standoffs (not sure what called). So I first had to solder those onto the chips, and then from there get them onto the breadboard and wired up. Another issues that I’ve still yet to be able to figure out is that these particular LEDs have the ability to have the data, voltage, and ground passed through them, but that wasn’t working for me and the spec sheet doesn’t have a lot of depth. Another learning I had was figuring out how to read data into the Arduino. This was my first time creating code for the device that would change how it behaves based on input. In the images you can see I’ve used jumper wires in an attempt to clean things up as much as possible. One thing that annoys me is the resistor next to the button is poking out so much.",
    body3: "I’d really like for the ability to leave everything wired up, but that would require me purchasing an entire new Arduino which would get expensive very quickly. So I’ll probably need a way document which pins are plugged in where before I start on the next project. ",
    variation: "elevated",
    date: "2022",
    image1: blue,
    image2: green,
    image3: red,
    image4: zoom,
    image1Size: "25%",
    image2Size: "25%",
    image3Size: "25%"
  },
  {
    index: 3,
    head: "G Class",
    body: (<>
      <p>
        This recently acquired 2016 Mercedes Benz G Wagon is displayed proudly for its debut
        <br/>
        <a href="https://www.mbusa.com/en/vehicles/class/g-class/suv" target="_blank" rel="noreferrer">G-Waggon</a>
      </p>
      </>
    ),
    variation: "elevated",
    date: "2025-08-30",
    image1: mb1,
    image2: mb2,
    image1Size: "35%",
    image2Size: "35%",
  },
  {
    index: 4,
    head: "RETRO APPLE",
    body: (<>
      <p>
        Lately, I've been spending a lot of time looking back at some retro tech. Specifically the G3 iBook, G3 iMac, and 2012 Mac Pro (5,1). 
        It's been quite fun refurbishing, upgrading, and installing retro software. Takes me back to some of my early days with my first computers, playing around in the settings when in the car without wifi.
        Black PCBs look incredible.
        <br/>
        <br/>
        <a href="https://www.macintoshrepository.org" target="_blank" rel="noreferrer">Macintosh Repository</a>
        <br/>
        <br/>
        <a href="https://www.youtube.com/watch?v=Mpfhr3jrQpc" target="_blank" rel="noreferrer">ShapeShifter - Mac OS X Panther 10.3 - Amora - David Lanham</a>
      </p>
      </>
    ),
    variation: "elevated",
    date: "2026-03-14",
    video1: ibinstall,
    video2: errMov,
    image1: amora,
    image2: Somatic,
    image3: ib9,
    image4: iBBoot,
    image5: ibinstall2,
    image6: iMac,
    image7: iMac2,
    image8: iMac3,
    image9: iMacTower,
    image10: gorg,
    image11: MacPro,
    image12: MacProDoor,
    image13: MacProMax,
    image14: MacProMotherboard,
    image15: mouse,
    image1Size: "35%",
    image2Size: "35%",
  },
  {
    index: 5,
    head: "RETRO APPLE Pt 2",
    body: (<>
      <p>
        Photo dump! I've been spending some time observing retro apple products to learn more about early technology. You'll see
        Cydia, Glasklart, BlueBird, and many other interesting photos.
        <br/>
        <br/>
        Tinkering has been quite enjoyable and it's quite fascinating looking back to see how computers used to work
        and how far we've come. I truly enjoy collecting high quality versions of retro tech, but if that weren't enough - I believe they will appreciate in value over time!
        Imagine that, a hobby that makes you money.. Another interesting thing to note - despite the power of these devices being quite low compared to today's standards, there is a lot
        that's actually better about older tech. To name a few examples, the Power Mac G3 Desktop is completely user serviceable - meaning you can swap out and upgrade almost every component on the system.
        HDD, CPU, Memory, Disk Readers, fans, and they are easy to clean too! Good luck finding anything like this in today's apple products. Additionally, there are technologies that just don't exist anymore.
        For example, ADC or Apple Display Connector. ADC is a proprietary apple standard which carries both display AND POWER through a single cable. Meaning - when you plug in your display, 
        that's all you need to do. The monitor doesn't need to be plugged into the wall. Not only that but it also carries a USB signal - which means you can plug your mouse and keyboard into the monitor, 
        and only have a single cable running from your monitor to your desktop and only a single cable from your desktop to the wall. Apple Monitors of this era even had touch sensitive keys 
        that can send brightness and power signals, so you can control your computer directly from the screen. 
        <br/>
        <br/>
        Finally, there is software.. One of the Machines I purchased came with a physical edition
        of Adobe Illustrator. If you have the disks and you have the serial, you have a lifetime copy. Sure it might not come with the latest and greatest features, 
        but there is only so much a product can change over time, so the majority of what you need is there. If most people understood this - they wouldn't pay Adobe's crazy subscription 
        prices. But they really don't have to worry about this. The computing industry has done everything in its power to make sure you are always on the latest and greatest versions. 
        Doing anything else is a pure PITA for those without a computing background. Another fun piece of tech is iTunes - we all remember when iTunes came out around the Napster and Limewire eras. 
        This technology was truly amazing, pay 99c for a song and you own it. The convenience factor was enough in and of itself to prevent people from pirating. Plus 
        you didn't have to worry about downloading viruses. Now - its as easy as ripping a Physical CD that you own, adding metadata, and you've got unlimited playback forever. 
        No Spotify subscriptions, no tracking of what you listen to. Just pure control over what you've purchased. These are a few examples that stick out to me as to 
        why technology has gotten worse over time. Sure its gotten better in a lot of other ways, but its always interesting to look back and appreciate what we used to have. 
      </p>
      </>
    ),
    variation: "elevated",
    date: "2026-06-03",
    image1: b5_1,
    caption1: "iPhone 3GS in pristine condition with box. Running iOS 6 - now Jailbroken! Takes me back to HS when I would charge my peers $20 bucks to jailbreak their iPod touch so they could pirate games.",
    image2: b5_2,
    caption2: "iPhone 5 in pristine condition with box. Purchased off of eBay quite some time ago - its really hard to find these devices in such good condition because these chrome edges would always take damage. This theme, Glasklart, was a huge innovation back in its day. That was around 2011, now in 2026 apple is coming full circle and making their design language 'liquid glass'",
    image3: b5_3,
    caption3: "Glasklart and Bluebird. Bluebird is one of my all time favorite themes. Made by David Lanham, one of my all-time favorite artists. Known for his Leopard theme Amora. Featured in previous photos.",
    image4: b5_4,
    caption4: "iMac G4 Flower Pot computer - such an awesome, beautiful design. This is the sort of stuff they just don't make anymore.",
    image5: b5_5,
    caption5: "From the Adobe Illustrator install disk - Retro F1 cars are sick",
    image6: b5_6,
    caption6: "From the Adobe Illustrator install disk - Whimsical design on what its like to work on computers",
    image7: b5_7,
    caption7: "Two different motherboard revisions for the G4 Power PC",
    image8: b5_8,
    caption8: "System crash - looks so cool",
    image9: b5_9,
    caption9: "System crash 2 - I think the cause ended up being the ethernet pcie card",
    image10: b5_10,
    caption10: "Purchased this Apple Display Untested - these are a bit of a gamble - if you get lucky, the seller legit has no way to test it - Given its an ADC display - only apple computers can plug into it unless you have a very special adapter. Unfortunately for me I did not get lucky on this one. As you can tell there are some graphics artifacts indicating something is failing in the display",
    image11: b5_11,
    caption11: "Another Crash - just looks cool idk",
    image12: b5_12,
    caption12: "Apple Desktop CPU - a board on a board - the connector is quite complex",
    image13: b5_13,
    caption13: "Apple Desktop CPU - closer look with the chip removed",
    image14: b5_14,
    caption14: "A fun collection display - Some of these boxes are worth more than the computers that go in them lol",
    image15: b5_15,
    caption15: "iTunes visualizer",
    image16: b5_16,
    caption16: "iTunes visualizer",
    image17: b5_17,
    caption17: "Now I've got all 3 major variants of the Apple Power PC G3 Desktop - This Mirror Disk Drive variant on the left is one of the most sought after - and I got it for a steal when purchasing a G4 Cube. ",
    image18: b5_18,
    caption18: "The Holy Grail - Apple G4 Cube - one of the rarest apple desktops - feels like you are pulling a fusion reactor core out when exposing the internals. Such a cool design",
    image19: b5_19,
    caption19: "Two iTunes Visualizers running at once",
    image20: b5_20,
    image21: b5_21,
    image22: b5_22,
    image23: b5_23,
    image24: b5_24,
    caption24: "Another angle of the awesome cube",
    image25: b5_25,
    caption25: "Mac OS X Server (10.5.4) - uploading a high res version here because MacintoshRepository is too busy fighting off DDOS attacks to render images in full resolution",
    image1Size: "35%",
    image2Size: "35%",
  },
].reverse();

// Optional per-photo text can be supplied alongside each image/video with a
// matching key: `caption1` for image1, `caption2` for image2, `caption3`..`caption25`
// for the numbered images, and `video1Caption` / `video2Caption` for the videos.
const buildMedia = (item) => {
  const media = [];
  if (item.image1) media.push({ type: 'image', src: item.image1, caption: item.caption1 });
  if (item.image2) media.push({ type: 'image', src: item.image2, caption: item.caption2 });
  if (item.video1) media.push({ type: 'video', src: item.video1, caption: item.video1Caption });
  if (item.video2) media.push({ type: 'video', src: item.video2, caption: item.video2Caption });
  for (let i = 3; i <= 25; i++) {
    if (item[`image${i}`]) media.push({ type: 'image', src: item[`image${i}`], caption: item[`caption${i}`] });
  }
  return media;
};

const BlogCardList = (props) => {
  const { dark } = props;

  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' && window.innerWidth <= 768
  );
  useEffect(() => {
    const update = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  const textPadding = isMobile ? { padding: '0 20px' } : {};
  const headerStyle = isMobile ? { padding: '4px 10px' } : {};
  const headBodyStyle = { textAlign: 'left', ...textPadding, ...(isMobile ? { fontSize: '1rem' } : {}) };
  const bodyStyle = { textAlign: 'left', ...textPadding, ...(isMobile ? { fontSize: '0.85rem' } : {}) };
  const cardPadding = isMobile ? "p-2" : "p-5";
  const sidePadding = isMobile ? "5%" : "5%";

  return (
    <div style={{ paddingRight: sidePadding, paddingLeft: sidePadding }} >
      <div>
        {items.map(item => {
          const media = buildMedia(item);
          return (
            <div key={item.head}>
              <br />
              <div className={`h-150 ${cardPadding}`}
                  style={getStyle(dark)}
                >
                  <h2 className={`${dark ? "text-white" : ""}`} style={headerStyle} > {item.head} </h2>
                  <hr></hr>

                  <MediaCarousel media={media} dark={dark} />
              </div>


              <br />
              <br />
              <div className="col-md-6">
                <div className={`h-100 ${cardPadding}`}
                  style={getStyle(dark)}
                >
                  <h2 className={`${dark ? "text-white" : ""}`} style={headerStyle} > {item.head} </h2>
                  <p className={`${dark ? "text-white" : ""}`} style={textPadding} > {"Date: " + item.date} </p>
                  <hr></hr>

                  {item.body ? (<h4 className={`${dark ? "text-white" : ""}`} style={headBodyStyle} > {item.body} </h4>) : ""}
                  {item.body2 ? (<p className={`${dark ? "text-white" : ""}`} style={bodyStyle} > {item.body2} </p>) : ""}
                  {item.body3 ? (<p className={`${dark ? "text-white" : ""}`} style={bodyStyle} > {item.body3} </p>) : ""}
                </div>
              </div>
              { space6 }
              { space6 }
            </div>
          )
        })}
      </div>
    </div>
  );
};

export default BlogCardList;